// Phase 9 R2 — Activate/deactivate via R1 RPC.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';

export function useSetInventoryItemActive() {
  const { activeShop } = useAuth();
  const qc = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, active }: { id: string; active: boolean }) => {
      const { data, error } = await supabase.rpc('set_inventory_item_active', {
        p_id: id,
        p_active: active,
      });
      if (error) throw error;
      return data;
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['inventory-items', activeShop?.id] });
      toast.success(vars.active ? 'Item activated' : 'Item deactivated');
    },
    onError: (e: any) => toast.error(e?.message ?? 'Failed to change status'),
  });
}
